import {
  Environment,
  KUBESOLO_PROVIDER,
} from '@/react/portainer/environments/types';
import { isAgentEnvironment } from '@/react/portainer/environments/utils';

const KUBESOLO_CLUSTER_TYPE = 'kubesolo';

/** Whether Portainer installed KubeSolo on the environment, or its latest snapshot detected it. Only an agent can reach KubeSolo's API, through the host's socket. */
export function isKubeSoloEnvironment(environment?: Environment) {
  return (
    !!environment &&
    isAgentEnvironment(environment.Type) &&
    (environment.CloudProvider?.Provider === KUBESOLO_PROVIDER ||
      environment.Kubernetes?.Snapshots?.[0]?.ClusterType ===
        KUBESOLO_CLUSTER_TYPE)
  );
}
